<template>
  <v-chart
    class="v-chart"
    :options="options"
    :init-options="{}"
    autoresize />
</template>

<script>
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legendScroll'
export default {
  name: 'StockPrecentChart',
  components: {
    'v-chart': ECharts
  },
  props: {
    legendData: {
      type: Array,
      default() {
        return []
      }
    },
    seriesData: {
      type: Array,
      default() {
        return []
      }
    },
    selected: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    options() {
      return {
        // title: {
        //     text: '同名数量统计',
        //     left: 'center'
        // },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}%'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 10,
          bottom: 10,
          data: this.legendData,
          selected: this.selected
        },
        series: [
          {
            name: '商品名称',
            type: 'pie',
            radius: '40%',
            center: ['40%', '50%'],
            data: this.seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-chart {
    height 300px!important
}
</style>
